<template>
  <div>
    <Head title="Liquidación" />
    <h1 class="mb-8 text-3xl font-bold">Liquidación</h1>
    <div>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-6 mb-6">
        <div class="bg-white p-6 rounded-lg shadow-lg">
          <div>
            <form @submit.prevent="filterByDate">
              <h2 class="text-xl font-bold mb-2 text-gray-800">Selecciona una ruta</h2>
              <div class="mb-4">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-end">
                  <div class="w-full">
                    <label class="block">
                      <span class="block text-base text-slate-500">Rutas:</span>
                      <Multiselect 
                        v-model="form.route_id" 
                        placeholder="Selecciona una opción"
                        :options="routes.map(route => ({ value: route.id, label: route.description }))" 
                        mode="single"
                        :close-on-select="true" 
                        :searchable="true" 
                        @change="showSubRouteC=false"
                      />
                    </label>
                  </div>
                  <div class="w-full">
                    <label class="block">
                      <span class="block text-base text-slate-500">Fecha ruta:</span>
                      <TextInput 
                        id="date_route" 
                        v-model="form.date_route" 
                        type="date" 
                        class="mt-1 block w-full" 
                      />
                    </label>
                  </div>
                  <div class="w-full flex items-end">
                    <button 
                      type="submit"
                      class="text-white bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center w-full"
                    >
                      Filtrar
                    </button>
                  </div>
                  <div v-if="days!=null && days.length>1 && showSubRouteC" class="w-full">
                    <label class="block">
                      <span class="block text-base text-slate-500">Sub-Ruta:</span>
                      <Multiselect 
                        v-model="form.day_id" 
                        placeholder="Selecciona una opción"
                        :options="days.map(day => ({ value: day.id_day, label: day.name }))"
                        mode="single"
                        :close-on-select="true" 
                        :searchable="true"
                      />
                    </label>
                  </div>
                  <div>
                    <Link
                      class="flex items-center px-2 py-4" 
                      :href="`liquidation/report/${form.route_id==null?routes.map(item=>item.id):form.route_id}/${form.date_route}/${form.day_id==null?days.map(item=>item.id_day):form.day_id}`"
                    >
                      <button class="px-4 py-3.5 bg-green-500 text-white rounded hover:bg-green-600 transition duration-300">
                        Generar Reporte
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Sección para mostrar datos de ruta -->
      <div v-for="(routeData, routeName) in reportData.routeTotals" :key="routeName" class="mb-8">
        <div v-for="store in routeData.stores" :key="store.id" class="mb-6 bg-white rounded-lg border border-gray-200">
          <div class="p-4 bg-gray-50 border-b">
            <div class="flex justify-between">
              <h3 class="font-bold text-lg">Tienda: {{ store.name }}</h3>
              <h3 class="font-bold text-lg">
                Tipo de pago: {{ store.purchase_type === 1 ? 'CONTADO' : (store.purchase_type === 2 ? 'CRÉDITO' : '') }}
              </h3>
              <h4 class="font-bold text-lg">
                Requiere factura: {{ store.invoice_required == 1 ? 'SI' : 'NO' }}
              </h4>
              <h3 class="font-bold text-lg">{{ store.folio ?? '0000000' }}</h3>
            </div>
            <p class="text-gray-600">Dirección: {{ store.address }}</p>
            <p v-if="store.details_visit" class="text-gray-700 mt-2">
              Observaciones: {{ store.details_visit }}
            </p>
          </div>
          <!-- Tabla de Productos -->
          <div class="overflow-x-auto">
            <table class="w-full">
              <thead>
                <tr class="bg-gray-50">
                  <th class="px-4 py-2 text-left">Producto</th>
                  <th class="px-4 py-2 text-right">Precio</th>
                  <th class="px-4 py-2 text-center">Cantidad</th>
                  <th class="px-4 py-2 text-right">Descuento</th>
                  <th class="px-4 py-2 text-center">Rechazo cajas</th>
                  <th class="px-4 py-2 text-center">Rechazo piezas</th>
                  <th class="px-4 py-2 text-right">Total</th>
                  <!-- <th class="px-4 py-2 text-center">Rechazar</th> -->
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="product in store.products" 
                  :key="product.name" 
                  class="border-t"
                >
                  <td class="px-4 py-2">{{ product.name }}</td>
                  <td class="px-4 py-2 text-right">{{ formatPrice(product.price) }}</td>
                  <!-- <td class="px-4 py-2 text-center">
                    {{ product.amount || 0 }} ({{ product.unit === 0 ? 'caja(s)' : 'pieza(s)' }})
                  </td> -->
                  <td class="px-4 py-2 text-center">
                    <div>
                      {{ product.amount || 0 }} {{ product.unit === 0 ? 'caja(s)' : 'pieza(s)' }}
                    </div>
                    <div v-if="product.rejection_boxes || product.rejection_pieces" class="text-sm text-red-600 mt-1">
                      - 
                      <span v-if="product.unit === 0 && product.rejection_boxes">
                        {{ product.rejection_boxes }} caja(s)
                      </span>
                      <span v-if="product.rejection_pieces">
                        {{ product.rejection_pieces }} pieza(s)
                      </span>
                    </div>
                  </td>
                  <!-- <td class="px-4 py-2 text-right">{{ product.discount ? formatPrice(product.discount) : 'N/A' }}</td> -->
                  <td 
                    class="px-4 py-2 text-right" 
                    :class="{ 'text-red-500': product.promotion_status === 1 }"
                  >
                    {{ product.discount ? formatPrice(product.discount) : 'N/A' }}
                  </td>

                  <!-- <td class="px-4 py-2 text-center">
                    <input 
                      type="checkbox" 
                      :checked="product.rejection_boxes !== null && product.rejection_boxes !== 0"
                      class="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
                      @change="openRejectModal(product, 'boxes')"
                    />
                  </td>
                  <td class="px-4 py-2 text-center">
                    <input 
                      type="checkbox" 
                      :checked="product.rejection_pieces !== null && product.rejection_pieces !== 0"
                      class="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
                      @change="openRejectModal(product, 'pieces')"
                    />
                  </td> -->
                  <td class="px-4 py-2 text-center">
                    <button 
                      type="button"
                      class="px-3 py-1 text-sm rounded-md"
                      :class="[
                        product.rejection_boxes !== null && product.rejection_boxes !== 0
                          ? 'bg-red-100 text-red-700 hover:bg-red-200'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      ]"
                      @click="openRejectModal(product, 'boxes')"
                    >
                      {{ product.rejection_boxes !== null && product.rejection_boxes !== 0 ? 'Rechazado' : 'Rechazar' }}
                    </button>
                  </td>
                  <td class="px-4 py-2 text-center">
                    <button 
                      type="button"
                      class="px-3 py-1 text-sm rounded-md"
                      :class="[
                        product.rejection_pieces !== null && product.rejection_pieces !== 0
                          ? 'bg-red-100 text-red-700 hover:bg-red-200'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      ]"
                      @click="openRejectModal(product, 'pieces')"
                    >
                      {{ product.rejection_pieces !== null && product.rejection_pieces !== 0 ? 'Rechazado' : 'Rechazar' }}
                    </button>
                  </td>
                  <td class="px-4 py-2 text-right">{{ formatPrice(product.total || 0) }}</td>
                </tr>
                <tr class="border-t bg-gray-50 font-bold">
                  <td colspan="4" class="px-4 py-2 text-right">Total</td>
                  <td class="px-4 py-2 text-right">{{ formatPrice(store.total) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- Total General -->
      <div class="bg-gray-100 p-4 rounded-lg mt-6">
        <div class="grid grid-cols-4 gap-4">
          <div class="text-gray-700 font-bold">Total General</div>
          <div class="text-gray-700">Total de Cajas: {{ reportData.grandTotal.boxes }}</div>
          <div class="text-gray-700">Total de Piezas: {{ reportData.grandTotal.pieces }}</div>
          <div class="text-gray-700 text-right font-bold">
            Total en Efectivo: {{ formatPrice(reportData.grandTotal.amount) }}
          </div>
        </div>
      </div>
    </div>
    <!-- Modal de Rechazo por Cajas -->
    <div v-if="showRejectBoxModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" @click="cancelReject('box')" />

        <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
                <h3 id="modal-title" class="text-lg leading-6 font-medium text-gray-900">
                  Rechazar cajas - {{ selectedProduct?.name }}
                </h3>
                <div class="mt-4">
                  <label class="block text-sm font-medium text-gray-700">
                    Cantidad de cajas a rechazar
                    <TextInput
                      v-model="rejectAmount"
                      type="number"
                      :min="0"
                      :max="selectedProduct ? selectedProduct.amount : 0"
                      class="mt-1 block w-full"
                    />
                  </label>
                  <p class="text-sm text-gray-500 mt-1">
                    Máximo disponible: {{ selectedProduct ? selectedProduct.amount : 0 }} cajas
                  </p>
                  <!-- Radio buttons para mantener descuento -->
                  <div v-if="hasDiscount" class="mt-4 space-y-2">
                    <p class="text-sm font-medium text-gray-700">Descuento:</p>
                    <div class="flex space-x-4">
                      <div class="flex items-center">
                        <input
                          id="keepDiscountBoxYes" 
                          v-model="keepDiscount"
                          type="radio"
                          :value="true"
                          class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                        />
                        <label for="keepDiscountBoxYes" class="ml-2 block text-sm text-gray-900">
                          Sí
                        </label>
                      </div>
                      <div class="flex items-center">
                        <input
                          id="keepDiscountBoxNo"
                          v-model="keepDiscount"
                          type="radio"
                          :value="false"
                          class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                        />
                        <label for="keepDiscountBoxNo" class="ml-2 block text-sm text-gray-900">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
              @click="confirmRejectBox"
            >
              Confirmar
            </button>
            <button
              type="button"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              @click="cancelReject('box')"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal de Rechazo por Piezas -->
    <div v-if="showRejectPiecesModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" @click="cancelReject('pieces')" />
        <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
                <h3 id="modal-title" class="text-lg leading-6 font-medium text-gray-900">
                  Rechazar piezas - {{ selectedProduct?.name }}
                </h3>
                <div class="mt-4 space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700">
                      Cantidad de piezas a rechazar
                      <TextInput
                        v-model="rejectPieces"
                        type="number"
                        :min="0"
                        class="mt-1 block w-full"
                      />
                    </label>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700">
                      Precio unitario por pieza
                      <TextInput
                        v-model="unitPrice"
                        type="number"
                        step="0.01"
                        min="0"
                        class="mt-1 block w-full"
                      />
                    </label>
                  </div>
                  <!-- Radio buttons para mantener descuento -->
                  <div v-if="hasDiscount" class="space-y-2">
                    <p class="text-sm font-medium text-gray-700">Mantener descuento original:</p>
                    <div class="flex space-x-4">
                      <div class="flex items-center">
                        <input
                          id="keepDiscountPiecesYes"
                          v-model="keepDiscount"
                          type="radio"
                          :value="true"
                          class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                        />
                        <label for="keepDiscountPiecesYes" class="ml-2 block text-sm text-gray-900">
                          Sí
                        </label>
                      </div>
                      <div class="flex items-center">
                        <input
                          id="keepDiscountPiecesNo"
                          v-model="keepDiscount"
                          type="radio"
                          :value="false"
                          class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                        />
                        <label for="keepDiscountPiecesNo" class="ml-2 block text-sm text-gray-900">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="pt-2 border-t border-gray-200">
                    <div class="flex justify-between text-sm font-medium text-gray-700">
                      <span>Total original:</span>
                      <span>{{ formatPrice(selectedProduct?.total || 0) }}</span>
                    </div>
                    <div class="flex justify-between text-sm font-medium text-gray-700 mt-1">
                      <span>Total a descontar:</span>
                      <span>-{{ formatPrice(calculateDiscount) }}</span>
                    </div>
                    <div class="flex justify-between text-sm font-bold text-gray-900 mt-2 pt-2 border-t">
                      <span>Nuevo total:</span>
                      <span>{{ formatPrice(calculateNewTotal) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
              @click="confirmRejectPieces"
            >
              Confirmar
            </button>
            <button
              type="button"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              @click="cancelReject('pieces')"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Link,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    filters: Object,
    routes: Array,
    reportData: {
      type: Object,
      required: true,
    },
    days: Array,
    showSubRoute: Boolean,
  },
  data() {
    return {
      form: {
        date_route: this.filters.date_route || new Date().toISOString().split('T')[0],
        route_id: this.filters.route_id || null,
        day_id : this.filters.day_id || this.days.map(item => item.id_day),
      },
      showRejectBoxModal: false,
      showRejectPiecesModal: false,
      rejectAmount: 0,
      rejectPieces: 0,
      unitPrice: 0,
      selectedProduct: null,
      keepDiscount: false,
      showSubRouteC: this.showSubRoute,
    }
  },
  computed: {
    hasDiscount() {
      console.log(this.selectedProduct)      
      return this.selectedProduct.discount 
    },
    calculateDiscount() {
      if (!this.selectedProduct) return 0      
      // Si el producto es por pieza (unit === 1), usar el precio original
      if (this.selectedProduct.unit === 1) {
        return this.rejectPieces * this.selectedProduct.price
      }
      // Si es por caja (unit === 0), usar el precio unitario ingresado
      return this.rejectPieces * this.unitPrice
    },
    calculateNewTotal() {
      if (!this.selectedProduct) return 0
      const newTotal = this.selectedProduct.total - this.calculateDiscount
      return Math.max(0, newTotal)
    },
    showUnitPriceInput() {
      // Solo mostrar input de precio unitario si es una caja (unit === 0)
      return this.selectedProduct?.unit === 0
    },
  },
  methods: {
    filterByDate() {
      console.log('ruta en filters '+this.filters.route_id+' En formulario '+this.form.route_id)
      this.form.day_id = this.showSubRouteC?this.form.day_id:null
      this.$inertia.get('/liquidation', this.form)
    },
    formatPrice(amount) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
      }).format(amount)
    },
    openRejectModal(product, type) {
      this.selectedProduct = product
      if (type === 'boxes') {
        this.rejectAmount = product.rejection_boxes || 0
        this.showRejectBoxModal = true
      } else {
        this.rejectPieces = product.rejection_pieces || 0
        // Solo reiniciar el precio unitario si es una caja
        this.unitPrice = product.unit === 0 ? 0 : product.price
        this.showRejectPiecesModal = true
      }
    },
    async confirmRejectBox() {
      try {
        await this.$inertia.post('/liquidation/reject', {
          order_detail_id: this.selectedProduct.id_order_detail,
          rejection_boxes: this.rejectAmount,
          amount: this.selectedProduct.amount,
          keep_discount: this.keepDiscount,
        })        
        this.showRejectBoxModal = false
        this.resetModalState()
      } catch (error) {
        console.error('Error al actualizar el rechazo de cajas:', error)
      }
    },
    resetModalState() {
      this.rejectAmount = 0
      this.rejectPieces = 0
      this.unitPrice = 0
      this.selectedProduct = null
      this.keepDiscount = false
    },
    async confirmRejectPieces() {
      try {
        const payload = {
          order_detail_id: this.selectedProduct.id_order_detail,
          rejection_pieces: this.rejectPieces,
          discount_amount: this.calculateDiscount,
          new_total: this.calculateNewTotal,
          keep_discount: this.keepDiscount,
        }
        // Solo incluir unit_price si el producto es por caja
        if (this.selectedProduct.unit === 0) {
          payload.unit_price = this.unitPrice
        }
        await this.$inertia.post('/liquidation/reject/pieces', payload)
        this.showRejectPiecesModal = false
        this.resetModalState()
      } catch (error) {
        console.error('Error al actualizar el rechazo de piezas:', error)
      }
    },
    cancelReject(type) {
      if (type === 'box') {
        this.showRejectBoxModal = false
      } else if (type === 'pieces') {
        this.showRejectPiecesModal = false
      }
      
      // Restaurar el estado original del producto seleccionado si existe
      if (this.selectedProduct) {
        if (type === 'box') {
          this.selectedProduct.rejection_boxes = this.selectedProduct.rejection_boxes || 0
        } else {
          this.selectedProduct.rejection_pieces = this.selectedProduct.rejection_pieces || 0
        }
      }
      
      this.resetModalState();
    },
    async handleReject(orderDetailId, isRejected, amount) {
      try {
        await this.$inertia.post('/liquidation/reject', {
          order_detail_id: orderDetailId,
          rejection_boxes: isRejected,
          amount: amount,
        })
      } catch (error) {
        console.error('Error al actualizar el rechazo:', error)
      }
    },
    async handleRejectPieces(orderDetailId, isRejected, amount) {
      try {
        await this.$inertia.post('/liquidation/reject/pieces', {
          order_detail_id: orderDetailId,
          rejection_pieces: isRejected,
          amount: amount,
        });
      } catch (error) {
        console.error('Error al actualizar el rechazo:', error)
      }
    },
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
